import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux';
import AppLayout from 'layouts/AppLayout';
import { 
	AUTH_PREFIX_PATH,
	APP_PREFIX_PATH, 
	UNAUTHENTICATED_ENTRY, 
	REDIRECT_URL_KEY 
} from 'configs/AppConfig'

const ProtectedRoute = () => {
	
	const { token } = useSelector(state => state.auth)
	const location = useLocation()


	// if (!token) {
	if (!localStorage.getItem('adminEmail') || !localStorage.getItem('userEmail')) {
		return <Navigate to={`${AUTH_PREFIX_PATH}${UNAUTHENTICATED_ENTRY}?userId=`} replace />;
		// return <Navigate to={`${AUTH_PREFIX_PATH}${UNAUTHENTICATED_ENTRY}?${REDIRECT_URL_KEY}=${location.pathname}`} replace />;
	}
	
	if (!token) {
		return <>
		<AppLayout>
			<Outlet to={`${APP_PREFIX_PATH}/callanalytics`} />
		</AppLayout>
		</>
	}

	return <Outlet />
}

export default ProtectedRoute